import { useLayoutEffect, useState } from 'react'

const DEFAULT_SCHEDULE_HEIGHT = '100%'
const STACKED_STAFF_TITLE_OFFSET = 36

const getScheduleHeight = (extraOffset = 0): string => {
  const scheduleHeader = document.getElementById('schedule-header-calendar')
  const root =
    (scheduleHeader?.closest('[data-schedule-root]') as HTMLElement | null) ??
    (scheduleHeader?.closest('.application-layout__content-container') as HTMLElement | null) ??
    document.querySelector<HTMLElement>('.application-layout__content-container')

  if (!root || !scheduleHeader) {
    return extraOffset ? `calc(100% - ${extraOffset}px)` : DEFAULT_SCHEDULE_HEIGHT
  }

  const style = getComputedStyle(root)
  const paddingY =
    (Number.parseFloat(style.paddingTop) || 0) + (Number.parseFloat(style.paddingBottom) || 0)
  const available = root.clientHeight - paddingY - scheduleHeader.offsetHeight - extraOffset
  return `${Math.max(available, 0)}px`
}

export const useScheduleHeight = (stacked = false) => {
  const extraOffset = stacked ? STACKED_STAFF_TITLE_OFFSET : 0
  const [scheduleHeight, setScheduleHeight] = useState(DEFAULT_SCHEDULE_HEIGHT)

  useLayoutEffect(() => {
    const updateHeight = () => setScheduleHeight(getScheduleHeight(extraOffset))
    updateHeight()

    const scheduleHeader = document.getElementById('schedule-header-calendar')
    const root =
      (scheduleHeader?.closest('[data-schedule-root]') as HTMLElement | null) ??
      (scheduleHeader?.closest('.application-layout__content-container') as HTMLElement | null) ??
      document.querySelector<HTMLElement>('.application-layout__content-container')

    window.addEventListener('resize', updateHeight)
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateHeight)
    if (root) observer?.observe(root)
    if (scheduleHeader) observer?.observe(scheduleHeader)

    return () => {
      window.removeEventListener('resize', updateHeight)
      observer?.disconnect()
    }
  }, [extraOffset])

  return scheduleHeight
}
